<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M10.4121 1.32094C10.9023 1.66406 11.0215 2.33955 10.6784 2.8297L5.59409 10.0926C5.59376 10.0931 5.59343 10.0936 5.5931 10.094C5.01714 10.92 3.88074 11.1234 3.05403 10.548C2.89348 10.4363 2.75194 10.2995 2.63483 10.1428C2.63451 10.1424 2.63419 10.142 2.63388 10.1415L1.34177 8.41897C0.982756 7.94034 1.07972 7.2613 1.55834 6.90229C2.03697 6.54327 2.71601 6.64024 3.07502 7.11886L4.08679 8.4677L8.90339 1.58716C9.24651 1.09701 9.922 0.977821 10.4121 1.32094ZM4.3704 8.84581L4.36936 8.84442L4.3704 8.84581Z"
    fill="white" />
</template>
